var render = function render(){var _vm=this,_c=_vm._self._c;return _c('provider-listing',{staticClass:"white-cards",attrs:{"query":{npi: _vm.npi, tier: _vm.tier, specialty: _vm.specialty, category: _vm.category, subcategory: _vm.subcategory, location: _vm.location}}})
}
var staticRenderFns = []

export { render, staticRenderFns }